import React, { useContext } from 'react'
import { Button } from '../index'
import { TextContext } from 'hocs'
import PropTypes from 'prop-types'

/**
 * concrete styled button component
 * used as separate component to use common click action (if required)
 * AND data-attributes
 *
 * @returns {*}
 * @constructor
 */
const LocalisationButton = ({ label, type = 'default' }) => {
  const textContext = useContext(TextContext)

  const clickHandler = () => {
    // console.log('TODO call js to show overlay for localisation')
  }

  return (
    <Button
      className={
        type === 'default'
          ? 'btn-primary btn-edit localisation-button'
          : 'btn btn-link localisation-button-small'
      }
      text={ label ? label : textContext['localization.button.changeLocation'] }
      data-localisation='dialog'
      data-event='localization'
      data-evalue='overlay'
      data-url='/?type=1444'
      onClick={ clickHandler }
    />
  )
}

LocalisationButton.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(['default', 'small']),
}

export default LocalisationButton
